import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import sweetAlert, {
sweetStatusAlert,
sweetConfirmAlert
} from "../../../components/common/SweetAlert.js";
import { currencyTypeService } from "../../../service/settings/manage/currency_type.service.js";
import { creditPriceService } from "../../../service/settings/manage/credit_price.service.js";
import Spinner from "react-bootstrap/Spinner";
import "../../../components/admin/css/common.css";
import {
Table,
TableHead,
TableRow,
TableBody,
TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import config from '../../../helper/config.js';
import {customerConstants} from "../../../helper/constants.js";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const getCustomerFeatureFlag = () => {
return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
case customerConstants.EXO_CUSTOMER1:
    break;
case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
    color: "var(--maincolor-cmc)",
    backgroundColor: "#E5F5FF",
    borderColor: "transparent",
    };
    addBtnStyle = {
    color: "#fff",
    backgroundColor: "var(--maincolor-cmc)",
    borderColor: "transparent",
    };
    break;
default:
    break;
}

export default class ManageCreditPrices extends Component {
constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
        showModal: false,
        creditPrices: [],
        currencyTypes: [],
        one_credit_price: "",
        currency_type_id: "",
        credit_price_id: "",
        modalType: false,
        search_val: "",
        isLoading: true,
        isSpinnerLoading: false,
        isModified: false,
        limit: 10, // Set the desired limit
        offset: 0, // Set the desired offset
        search_term: "",
        sort_column: "credit_price_id",
        sort_direction: "ASC",
        totalCreditPrices: 10,
        currentPage: 0,
        editVisibility: true,
        addVisibility: true,
        deleteVisibility: true,
        one_credit_price_error: "",
        disabled: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllCreditPriceData, 2000);
}

resetFormFields = () => {
    this.setState({
        one_credit_price: "",
        currency_type_id: "",
    });
};

componentDidMount() {
    this.getAllCurrencyTypes();
    this.fetchAllCreditPriceData();
}

createValidationsInstance() {
    this.validator = new SimpleReactValidator();
}

getAllCurrencyTypes = async() => {
    this.setState({ isLoading: true });
    await currencyTypeService.getAllCurrencyTypes()
    .then((response) => {
        if (response.success) {
        this.setState({
            currencyTypes: response.data.currency_types
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching Currency Types. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching currency types. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false });
    });
}

getCurrencyTypeSymbol(currency_type_id) {
    if (currency_type_id !== null) {
        const currency_type = this.state.currencyTypes?.find(
            (currency_type) => currency_type.currency_type_id == parseInt(currency_type_id)
        );
        return currency_type?.symbol;
    }
    else{
        return "N/A";
    }
}

fetchAllCreditPriceData() {
    const { limit, offset, search_term, sort_column, sort_direction } = this.state;
    creditPriceService.getAll(limit, offset, search_term, sort_column, sort_direction)
    .then((response) => {
        if (response.success) {
        this.setState({
            creditPrices: response.data.credit_prices,
            totalCreditPrices: parseInt(response.data.total_count),
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching credit prices. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching credit prices. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false, isSpinnerLoading: false });
    });
}

handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllCreditPriceData();
    }
    );
};

handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
        currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
        {
            sort_column,
            sort_direction: newSortDirection,
            offset: 0, // Reset offset when changing sorting
            currentPage: 0,
            isLoading: true,
        },
        () => {
            this.fetchAllCreditPriceData();
        }
    );
};

handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage
    },
    () => {
        this.fetchAllCreditPriceData();
    }
    );
};

handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
    {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllCreditPriceData();
    }
    );
};

handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
    this.setState(
        {
            search_term,
            isLoading: true,
            offset: 0,
            currentPage: 0,
            searchError: false,
            },
            () => {
            this.debouncedHandleSearch();
        }
    );
    } else {
        this.setState({ search_term, searchError: true });
    }
};

toggleCreditPriceModal = (modalType) => {
    this.modalType = modalType;
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
    }));
};

toggleUpdateCreditPriceModal = (one_credit_price, currency_type_id, credit_price_id, modalType) => {
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
        one_credit_price: one_credit_price,
        currency_type_id: currency_type_id,
        credit_price_id: credit_price_id,
        modalType: modalType,
    }));
};

handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
};

handleChangeCurrencyType = (event) => {
    event.preventDefault();
    this.setState({ currency_type_id: event.target.value });
};
  
handleSweetAlert = (modalType, modalVisibility) => {
    if (this.state.isModified) {
        sweetAlert().then((response) => {
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.modalType = false;
            this.setState(() => ({
            [modalVisibility]: response,
            isModified: false,
            }));
        });
    } else {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        if (modalType) this.toggleCreditPriceModal(false);
        else this.toggleUpdateCreditPriceModal();
    }
};

//Handle Edit Submit
handleEditSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const creditPriceItem = {
            one_credit_price: this.state.one_credit_price,
            currency_type_id: this.state.currency_type_id
        };
        const creditPriceId = this.state.credit_price_id;

        creditPriceService.updateCreditPrice(creditPriceItem, creditPriceId)
            .then((response) => {
            if (response.success) {
                this.setState({ isSpinnerLoading: false });
                this.toggleCreditPriceModal();
                sweetStatusAlert(
                    "Success!",
                    "Credit price information updated successfully!",
                    "success"
                );
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.fetchAllCreditPriceData();
            }else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert(
                "Failed!",
                "Unable to update the credit price information",
                "error"
            );
            });
    }
};

//add new Credit Price
handleSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const { one_credit_price, currency_type_id } = this.state;
        const newCreditPriceItem = { one_credit_price: one_credit_price, currency_type_id: currency_type_id};

        creditPriceService.addCreditPrice(newCreditPriceItem)
            .then((response) => {
            if (response.success) {
                sweetStatusAlert("Success!", response.message.success, "success");
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.toggleCreditPriceModal(false);
                this.fetchAllCreditPriceData();
            } else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message.error, "error");
            }
            })
            .catch((err) => {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", "Unable to create new credit price", "error");
            });
    }
};

handleDeleteCreditPrice = (id) => {
    sweetConfirmAlert().then(() => {
    this.setState({ isSpinnerLoading: true });
    creditPriceService.deleteCreditPrice(id)
        .then((response) => {
        this.setState({ isSpinnerLoading: false });
        if (response.success) {
            sweetStatusAlert("Success!", response.message.success, "success");
            this.fetchAllCreditPriceData();
        } else {
            sweetStatusAlert("Failed!", response.message, "error");
        }
        })
        .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert("Oops!", "Error while deleting the credit price", "info");
        });
    });
};

render() {
    const {
        limit,
        creditPrices,
        totalCreditPrices,
        isLoading,
        currentPage,
        isSpinnerLoading,
        editVisibility,
        addVisibility,
        deleteVisibility,
    } = this.state;
    return (
    <>
        <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
            <h3 className="text-nowrap">Manage One Credit Prices</h3>
            </div>
            <div>
            {/* {addVisibility && (
                <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={() => this.toggleCreditPriceModal(true)}
                >
                    Add One Credit Price
                </Button>
            )} */}
            </div>
        </div>
        <div>
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
            <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="col-md-3 col-12"
            />
            {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                    Invalid input
                </Form.Control.Feedback>
            )}
            </Form.Group>
            {isSpinnerLoading && (
            <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isLoading ? (
            <div
                className="loading-container"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "75vw",
                    height: "90vh",
                }}
            >
                <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
            ) : creditPrices.length > 0 ? (
            <div style={{ width: "100%", height: "90vh", overflow: "auto" }}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("credit_price_id")}
                    >
                        No{" "}
                        {this.state.sort_column === "credit_price_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    {/* <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("currency_type_id")}
                    >
                        Currency Type{" "}
                        {this.state.sort_column === "currency_type_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell> */}
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("one_credit_price")}
                    >
                        One Credit Price{" "}
                        {this.state.sort_column === "one_credit_price" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    {(editVisibility || deleteVisibility) && (
                        <TableCell className="thead">Actions</TableCell>
                    )}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {creditPrices.map((creditPriceItem) => (
                    <TableRow key={creditPriceItem.credit_price_id}>
                        <TableCell className="tData">
                            {creditPriceItem.credit_price_id}
                        </TableCell>
                        {/* <TableCell className="tData">
                            {creditPriceItem.name}
                        </TableCell> */}
                        <TableCell className="tData">
                            {this.getCurrencyTypeSymbol(creditPriceItem.currency_type_id) + " "  + parseInt(creditPriceItem.one_credit_price)}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                        <TableCell>
                            <div className="btn-group">
                            {editVisibility && (
                                <Button
                                    onClick={() =>
                                        this.toggleUpdateCreditPriceModal(
                                            creditPriceItem.one_credit_price,
                                            creditPriceItem.currency_type_id,
                                            creditPriceItem.credit_price_id,
                                            false
                                        )
                                    }
                                    className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                    title="Edit Details"
                                />
                            )}
                            {/* {deleteVisibility && (
                                <Button
                                    onClick={() =>
                                        this.handleDeleteCreditPrice(
                                            creditPriceItem.credit_price_id
                                        )
                                    }
                                    className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                    title="Delete"
                                />
                            )} */}
                            </div>
                        </TableCell>
                        )}
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
                <MaterialCustomTablePagination
                    totalCount = {totalCreditPrices}
                    currentPage = {currentPage}
                    limit = {limit}
                    handlePageChange = {this.handlePageChange}
                    handleRowsPerPageChange = {this.handleRowsPerPageChange}
                    handlePageOffsetChange = {this.handlePageOffsetChange}
                    offset = {this.state.offset}
                    rowsPerPageOptions={[5, 10, 20]}
                />
            </div>
            ) : (
            <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
            >
                <label>No Credit Prices Available!</label>
            </div>
            )}
        </div>
        </ContentWrapper>

        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
        >
        {this.modalType === true ? (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Create One Credit Price</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>One Credit Price *</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Control
                            type="number"
                            placeholder="Enter one credit price value..."
                            name="one_credit_price"
                            value={this.state.one_credit_price || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value <= 0) {
                                    this.setState({ one_credit_price_error: "Enter a positive number", disabled: true });
                                } else {
                                    this.setState({ one_credit_price: value, one_credit_price_error: "", disabled: false });
                                }
                                this.handleChange(e);
                            }}
                            style={{ width: '70%', marginRight: '5px' }}
                        />
                        <Form.Select
                            id="currency_type"
                            value={this.state.currency_type_id}
                            onChange={this.handleChangeCurrencyType}
                            className="form-control"
                            style={{ width: '30%' }}
                        >
                        {this.state.currencyTypes.map((option, index) => (
                            <option key={index} value={option.currency_type_id}>
                                {option.name}
                            </option>
                        ))}
                        </Form.Select>
                    </div>
                    {this.state.one_credit_price_error && (
                        <div className="text-danger">{this.state.one_credit_price_error}</div>
                    )}
                    {this.validator.message(
                        "one_credit_price", 
                        this.state.one_credit_price, 
                        "required|number", 
                        {className: "text-danger"}
                    )} 
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleSubmit}
                    disabled={this.state.disabled}
                >
                    Save changes
                </Button>
                <Button
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        ) : (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Update One Credit Price</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>One Credit Price *</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Control
                            type="number"
                            name="one_credit_price"
                            placeholder="Type one credit price here..."
                            value={this.state.one_credit_price}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value <= 0) {
                                    this.setState({ one_credit_price_error: "Enter a positive number", disabled: true });
                                } else {
                                    this.setState({ one_credit_price: value, one_credit_price_error: "", disabled: false });
                                }
                                this.handleChange(e);
                            }}
                            min={0}
                            style={{ width: '70%', marginRight: '5px' }}
                        />
                        <Form.Select
                            id="currency_type"
                            value={this.state.currency_type_id}
                            onChange={this.handleChangeCurrencyType}
                            className="form-control"
                            style={{ width: '30%' }}
                            disabled={true}
                        >
                        {this.state.currencyTypes.map((option, index) => (
                            <option key={index} value={option.currency_type_id}>
                                {option.name}
                            </option>
                        ))}
                        </Form.Select>
                    </div>
                    {this.state.one_credit_price_error && (
                        <div className="text-danger">{this.state.one_credit_price_error}</div>
                    )}
                    {this.validator.message(
                        "one_credit_price", 
                        this.state.one_credit_price, 
                        "required|number", 
                        {className: "text-danger"}
                    )} 
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="modal-btn"
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleEditSubmit}
                    disabled={this.state.disabled}
                >
                    Save changes
                </Button>
                <Button
                    className="modal-btn"
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        )}
        </Modal>
    </>
    );
}
}
